import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ActivationCodeState extends UltMeta {
    UNUSED = new Meta(1, "未使用");
    USED = new Meta(2, "已使用");
    OVERDUE = new Meta(3, "过期");
}

export const ACTIVATION_CODE_STATE = new ActivationCodeState();

class HasBind extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}
export const HAS_BIND = new HasBind();

class ErrorMessage extends UltMeta {
    REDEMPTION_SUCCESS = new Meta(1, "兑换成功");
    REDEMPTION_FAILED = new Meta(2, "兑换失败!激活码已过期!");
    ACTIVATION_CODE_INVALID = new Meta(3, "激活码无效!请输入正确的激活码!");
    ACTIVATION_FAILED = new Meta(4, "兑换失败!该激活码已被兑换!");
    REDEMPTION_CLOSED = new Meta(5, "兑换失败!该会员已关闭兑换，请联系平台!");
    RECEIVE_FAILED = new Meta(6, "该活动仅限新用户参加");
    RECEIVE_SUCCESS = new Meta(7, "领取成功");
}

export const ERROR_MESSAGE = new ErrorMessage();
